/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { useRequest } from '../../hooks/UseRequest'
import Loading from '../../components/Loading'
import NoRecord from '../../components/elements/NoRecord'

function CutoffTimeDashlet() {
  const requests = useRequest()
  const requesting = useRef(false)
  const [row, setRow] = useState([])
  const [loaded, setLoaded] = useState(false)
  const endpointPath = `${process.env.REACT_APP_API_DOMAIN}/payment_processor/cutoff_time/dashlet`

  useEffect(() => {
    const getRow = async () => {
      requests.setEndpoint(endpointPath)
      try {
        const response = await requests.get()
        setRow(response.data.data)
        setLoaded(true)
      } catch (error) {
        setLoaded(true)
      }
    }
    if (!requesting.current && endpointPath && row.length === 0) {
      setLoaded(false)
      requesting.current = true
      getRow()
    }
  }, [])

  return (
    <div className="message is-white lox-dashlet-detail">
      <div className="message-header has-background-primary has-text-white lox-dashlet-detail__title py-0">
        <p className="is-size-4">Cut-off Times</p>
      </div>
      <div className="message-body py-0 px-1">
        {loaded && row &&
          row?.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={index}>
              <div className="columns m-0">
                <div className={`column py-1 px-0`}>
                  <span className="lox-dashlet-detail__item__label has-text-grey is-size-8 pl-2">
                    {item.name}
                  </span>
                </div>
                <div className={`column ml-1 py-1 px-0`}>
                  <div className="lox-dashlet-detail__item py-0 px-1">
                    <span className="lox-dashlet-detail__item__data has-text-link is-size-8 pl-2">
                      {item.cutoff_time}
                    </span>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))}
        {!loaded && <Loading />}
        {loaded && row.length === 0 && <NoRecord />}
      </div>
    </div>
  )
}

export default CutoffTimeDashlet
